import LinkIcon from '@mui/icons-material/Link';
import {Box, Link, Typography} from '@mui/material';
import {FetchOrderlinesDataWrapper} from 'src/app/components/data-wrappers/orderline/FetchOrderlinesDataWrapper';
import Orderline from 'src/data/models/orderline/orderline';
import Popover from 'src/view/components/popover/Popover';

interface LinkedOrderlinesPopOverProps {
    eventId: string;
    linkGroupId: string;
    orderlineId: string;
    onSelectOrderline: (orderline: Orderline) => void;
}

export const LinkedOrderlinesPopOver = ({
    eventId,
    linkGroupId,
    orderlineId,
    onSelectOrderline,
}: LinkedOrderlinesPopOverProps) => (
    <Popover
        trigger="click"
        isLink={false}
        boxPadding={8}
        text={<LinkIcon fontSize="small" titleAccess="Linked to other orderlines"/>}
    >
        <FetchOrderlinesDataWrapper
            eventId={eventId}
            filter={[{property: 'linkGroupId', value: linkGroupId}]}
        >
            {({loading, data}) => (
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.5}}>
                    <Typography variant="caption" color="text.secondary">
                        Linked to
                    </Typography>
                    {loading ? (
                        <Typography variant="body2">Loading…</Typography>
                    ) : (
                        (data?.data || [])
                            .filter((o) => o.id !== orderlineId)
                            .map((o) => (
                                <Link
                                    key={o.id}
                                    component="button"
                                    type="button"
                                    variant="body2"
                                    underline="hover"
                                    onClick={() => onSelectOrderline(o)}
                                >
                                    {o.orderSummary?.orderNumber}
                                </Link>
                            ))
                    )}
                </Box>
            )}
        </FetchOrderlinesDataWrapper>
    </Popover>
);
